import React, { Component, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Route, BrowserRouter as Router } from "react-router-dom";
import "./App.scss";

import { AuthProvider } from "./utils/auth";
import PrivateRoute from "./Routes/privateRoute";

import { ROUTES } from "./Routes/routes";
import AppRoutes from "./AppRoutes";
import Spinner from "./components/Spinner";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // this.onRouteChanged();
  }

  renderRoutes() {
    return ROUTES.map((route) => {
      const routeKey = `${route.key} ${route.title}`;
      if (route.isPrivate)
        return (
          <PrivateRoute
            exact
            key={routeKey}
            path={route.link}
            component={route.component}
          />
        );
      return (
        <Route
          exact
          key={routeKey}
          path={route.link}
          component={route.component}
        />
      );
    });
  }

  render() {
    return (
      <Suspense fallback={<Spinner />}>
        <AuthProvider>
          <Router>
            <AppRoutes />
          </Router>
        </AuthProvider>
      </Suspense>
    );
  }

  componentDidUpdate(prevProps) {
    // console.log(" prevProps.location:", this.props.location);
    // this.onRouteChanged();
    // if (this.props.location !== prevProps.location) {
    //   //this.onRouteChanged();
    // }
  }
  onRouteChanged() {
    console.log("ROUTE CHANGED");

    const body = document.querySelector("body");
    window.scrollTo(0, 0);

    console.log("ROUTES:", window.location.pathname);
    const currentRouteItem = ROUTES.find(
      (v) => v.link === window.location.pathname
    );
    console.log("currentRouteItem:", currentRouteItem);

    if (currentRouteItem.isFullPageLayout) {
      this.setState({
        isFullPageLayout: true,
      });
      // document
      //   .querySelector(".page-body-wrapper")
      //   .classList.add("full-page-wrapper");
    } else {
      this.setState({
        isFullPageLayout: false,
      });
      // document.querySelector('.page-body-wrapper').classList.remove('full-page-wrapper');
    }

    //console.log("ROUTES:",ROUTES);
    // let location = useLocation();
    // console.log("Route changed:",location );
  }
}
